/**
 * Le rappel d'achat, en bas de page.
 *
 * Le lien passe par la liste blanche du serveur (relatif, https: ou
 * mailto:) : rien à vérifier ici, la validation a eu lieu à l'écriture.
 */
const BandeauCtaBloc = ({ bloc }) => {
    if (!bloc?.titre && !bloc?.lienTexte) return null;

    return (
        <section className="mb-10" data-testid="bloc-bandeauCta">
            <div className="rounded-2xl px-6 py-8 text-center bg-gradient-to-r from-cabaza-purple to-cabaza-pink">
                {bloc.titre && (
                    <h2 className="text-xl md:text-2xl font-bold text-white mb-2">{bloc.titre}</h2>
                )}
                {bloc.sousTitre && (
                    <p className="text-white/90 mb-5 max-w-xl mx-auto">{bloc.sousTitre}</p>
                )}
                {bloc.lienTexte && bloc.lien && (
                    <a
                        href={bloc.lien}
                        className="inline-flex items-center justify-center px-6 py-3 rounded-xl font-semibold text-cabaza-purple bg-white hover:bg-gray-50 transition"
                    >
                        {bloc.lienTexte}
                    </a>
                )}
            </div>
        </section>
    );
};

export default BandeauCtaBloc;
